import React from 'react';
import Block from './Block';
import {Carousel} from './CardContainers';
import Title from './Title';

export function TitledBlockCarousel({Card, size, type}) {
    return (
        <div className={'loading--titled-block-carousel'}>
            <Title type={type} />
            <Block size={size} />
            <Carousel Card={Card} noTitle size={size} type={type} />
        </div>
    );
}

export default TitledBlockCarousel;
